import styled, { css } from 'styled-components';
import { WarningBanner } from 'ui/banner';
import { colors, smallShadow, spacing } from 'ui/theme';
import { TileRadio } from 'ui/radio/TileRadio';

export const EntrySourceSelect = styled.div`
  padding: ${spacing.base};
`;

export const RadioOptions = styled.div`
  display: grid;
  gap: ${spacing.base};
  grid-template-columns: repeat(4, 1fr);
`;

export const StyledTileRadio = styled(TileRadio)<{
  isChecked?: boolean;
  isDisabled?: boolean;
}>`
  height: 100%;
  ${smallShadow}

  ${({ isChecked, isDisabled }) =>
    !isChecked &&
    !isDisabled &&
    css`
      :hover {
        border-color: ${colors.green50};
      }
    `}
`;

export const IconWrapper = styled.div`
  margin-top: -${spacing.plusHalf};
`;

export const StyledWarningBanner = styled(WarningBanner)`
  margin-bottom: ${spacing.double};
`;
